import React, { useState, useContext } from "react";
import { StoreContext } from "../store/Store";
import { actionTypes } from "../store/storeTypes";
import { saveConfig, getConfigList } from "../api/s3";

const style = {
  padding: 2,
  paddingLeft: 5,
  paddingRight: 5,
  border: "1px solid black",
};
const buttonStyle = {
  marginLeft: 10,
  border: "1px solid #000000",
  borderRadius: 6,
  padding: 3,
  fontSize: 12,
  cursor: "pointer",
};

export const PanelSelector = ({ panel, setPanel, panels, configId }) => {
  const [showList, setShowList] = useState(false);
  const [configList, setConfigList] = useState();

  const [store, dispatch] = useContext(StoreContext);
  const { auth, flowConfig } = store;

  const onSave = () => {
    const version = prompt(
      "Please provide version description",
      flowConfig.source
    );
    const asyncfunction = async () => {
      const payload = { ...flowConfig };
      payload["id"] = configId;
      payload["version"] = version;
      payload["source"] = version;
      await saveConfig(auth, payload);
      dispatch({ type: actionTypes.SET_FLOWCONFIG, payload: payload });
    };
    if (version) {
      asyncfunction();
    }
  };

  const setDefaultConfig = (val) => {
    const asyncfunction = async () => {
      setShowList(false);
      await saveConfig(auth, val);
      dispatch({ type: actionTypes.SET_FLOWCONFIG, payload: val });
      dispatch({ type: actionTypes.SET_NEWFLOWLAYOUTTRIGGER, payload: true });
    };
    asyncfunction();
  };

  const onCancel = () => {
    setShowList(false);
  };

  const onLoad = () => {
    const asyncfunction = async () => {
      const ret = await getConfigList(auth, configId);

      console.log("ret", ret);
      setConfigList(ret.filter((item) => item.version !== "default"));
      setShowList(true);
    };
    asyncfunction();
  };

  const popupstyle = {
    position: "absolute",
    top: 100,
    right: 20,
    border: "1px solid #000000",
    backgroundColor: "#ffffff",
    padding: 30,
    maxWidth: 200,
    zIndex: 1,
  };

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        marginTop: 10,
        display: "flex",
      }}
    >
      <div
        style={{
          // width: "310px",
          display: "flex",
          flexWrap: "wrap",
          flex: 9,
        }}
      >
        {panels.map((item, i) => {
          return (
            <div
              onClick={() => setPanel(item)}
              key={i}
              style={{
                ...style,
                backgroundColor: item === panel ? "grey" : "white",
                color: item === panel ? "white" : "black",
              }}
            >
              {item}
            </div>
          );
        })}
      </div>

      <div style={{ flex: 1 }}>
        <div onClick={() => onSave()} style={buttonStyle}>
          Save
        </div>
        <div onClick={() => onLoad()} style={buttonStyle}>
          Load
        </div>
      </div>

      {showList && (
        <div style={popupstyle}>
          {configList.map((item, i) => {
            return (
              <div key={i} style={{ display: "flex" }}>
                <input
                  type={"checkbox"}
                  onChange={() => setDefaultConfig(item)}
                ></input>
                <div>{item.version}</div>
              </div>
            );
          })}
          <div
            onClick={() => onCancel()}
            style={{ ...buttonStyle, marginTop: 20 }}
          >
            Cancel
          </div>
        </div>
      )}
    </div>
  );
};
